import Vue from 'vue';

const success = (context, response, toPage) => {
  context.loading = false;
  toastr.success(response.data.msg);
  if (response.data.sync === true) {
    toastr.success(context.$t("home.sync_in_process_text_4"));
  }
  if (toPage === 'rental-list') {
    Vue.router.push({
      name: 'rentals.index',
    });
  }
};

const failed = (error, context) => {
  if(error && error.response && error.response.data && error.response.data.error && error.response.data.error === 'no_active_subscription') {
    context.loading = false;
    context.openModal('#add-card-modal');
  } else {
    if (error.response) {
      context.loading = false;
      context.showToasterError(error);
    }
  }
};

export default (context, rental, toPage) => {
  return Vue.$http.put(`/rentals/${rental.id}`, rental)
    .then(response => {
      if(response && response.status === 200) {
        success(context, response, toPage);
      }
    }).catch(error => {
      failed(error, context);
    })
}



// WEBPACK FOOTER //
// ./src/app/services/rental/updateRental.js